import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ReceivableService from "services/ReceivableService";

export const index = createAsyncThunk(
  "recievable/index",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ReceivableService.index(data);

      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error");
    }
  }
);

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  drawer: false,
  recievables: [],
  recievable: {},
};

export const receivableSlice = createSlice({
  name: "recievable",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(index.pending, (state) => {
        state.loading = true;
      })
      .addCase(index.fulfilled, (state, action) => {
        state.loading = false;
        state.recievables = action.payload;
      })
      .addCase(index.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      });
  },
});

export const {} = receivableSlice.actions;

export default receivableSlice.reducer;
